/**
*
* Disclaimer: Source code mentioned below is(are) Intellectual Property of
* Crayon Data Holdings Limited (including its subsidiaries and affiliates).
* Crayon Data Holdings Limited reserves right to own and control it the way
* it may deem fit. You must refrain from use, access, read, modify, add or
* delete, sell or use in any other package or programme pertaining to such
* source code without explicit prior written approval of
* Crayon Data Holding Limited. Breach of the same shall attract penalty as
* applicable.
*
*/

// Button Component

import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import Icon from "../Icons";
import { addToClass } from "../../helper/style";
import uiConfig from "../../uiConfig";
import config from "../../service/config";

//Main Component
const Button = (props) => {
  const { variant, size, label, onClick, isDisabled, iconName } = props;

  function handleClick() {
    if (onClick) {
      onClick();
    }
  }

  const cls = {
    btn: true,
    "btn-dis": isDisabled
  };

  addToClass(
    cls,
    {
      primary: "btn-prm",
      success: "btn-scs",
      secondary: "btn-sec",
      normal: "btn-nrm",
      link: "btn-lnk",
      error: "btn-err",
      review: "btn-rew",
      moreOffer:'btn-offers'
    },
    variant
  );

  addToClass(
    cls,
    {
      small: "btn-sml",
      medium: "btn-med",
      big: "btn-big",
      large: "btn-lrg"
    },
    size
  );

  return (
    <button className={clsx(cls)} onClick={handleClick} disabled={isDisabled}
   style={{backgroundColor:variant&&variant==="primary"&&uiConfig.config.whitelabel.components.button.backgroundColor}}
        >
      {iconName && (
        <span className="mr-5">
          <Icon name={iconName} height={14} width={14} />
        </span>
      )}
      {label}
    </button>
  );
};

Button.propTypes = {
  variant: PropTypes.oneOf("normal", "primary", "secondary", "error", "link", "review"),
  size: PropTypes.oneOf("sm", "md", "lg"),
  label: PropTypes.string,
  iconName: PropTypes.string,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool
};

Button.defaultProps = {
  variant: "normal",
  size: "sm",
  label: "",
  iconName: "",
  onClick: null,
  isDisabled: false
};

export default Button;
